import {defineField} from 'sanity'

export default defineField({
  name: 'portableText',
  type: 'array',
  of: [{type: 'block'}],
})
